


















import { Component, Mixins } from "vue-property-decorator";
import { DeveloperPresentableMixin, DeveloperQuittableMixin } from "./mixins";
import Overview from "./contents/Overview.vue";
import StoreEditor from "./contents/StoreEditor.vue";
import LocalStorageEditor from "./contents/LocalStorageEditor.vue";
import DataBaseEditor from "./contents/DataBaseEditor.vue";
import PerformanceViewer from "./contents/PerformanceViewer.vue";
import BrowserInformationViewer from "./contents/BrowserInformationViewer.vue";
import PointerEventsViewer from "./contents/PointerEventsViewer.vue";
import AssemblyVersionViewer from "./contents/AssemblyVersionViewer.vue";

@Component({
  components: {
    Overview,
    StoreEditor,
    LocalStorageEditor,
    DataBaseEditor,
    PerformanceViewer,
    BrowserInformationViewer,
    PointerEventsViewer,
    AssemblyVersionViewer,
  }
})
export default class DeveloperContents extends Mixins(DeveloperPresentableMixin, DeveloperQuittableMixin) {
  data(): any {
    return {
      selectedContent: "overview",
    };
  }
  selectedContent: string;

  selectContent(key: string): void {
    this.selectedContent = key;
  }
}
